
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[category]/[slug]",
      function () {
        return require("private-next-pages/services/[category]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[category]/[slug]"])
      });
    }
  